class HelperAnalyticsEvent {

  static defaultInfo = () => {
    return {
      pageInfo: window.adobeDataLayer?.[0]?._avnet?.pageInfo || {},
      userInfo: window.adobeDataLayer?.[0]?._avnet?.userInfo || {}
    }
  }

  static internalSearchEvent(dataPoints) {
    const Info = this.defaultInfo()
    let searchDetails = dataPoints.searchDetails;
    const searchEvent = {
      event: "internalSearchCompleted",
      _avnet: {
        internalSearchInfo: {
          searchType: "internal",
          searchTerm: searchDetails.searchTerm,
          searchResultsCount: searchDetails.count,
          numberOfPagesReturned: searchDetails.pageCount,
          searchTab: "Products",
          searchPagination: searchDetails.isPagination,
        },
        ...Info
      },
    };
    window.adobeDataLayer?.push(searchEvent);
  }

  static cartEvent(dataPoints) {
    const Info = this.defaultInfo()
    let productDetails = dataPoints?.prodDetails;
    let cartDetails = dataPoints?.cartDetails;
   
    let cartEventObj = {
      event: 'addToCartEvent',
      _avnet: {
        productListItems: [
          {
            "SKU": productDetails?.itemNumber,
            "name": productDetails?.erpMfrPartNumber,
            "currencyCode": productDetails?.currency,
            "quantity": productDetails?.quantity,
            "priceTotal": productDetails?.subtotal,
            "productImageUrl": productDetails?.assetURL,
            "category": productDetails?.categoryListing?.length
            ? categoryArr(productDetails.categoryListing)
            : "",
            "merchandising": {
              "erpPartKey": productDetails?.erpMfrPartNumber,
              "pimPartKey": productDetails?.itemNumber,
              "supplierID": "",
              "supplierPartNumber": "",
              "manufacturerID": productDetails?.manufacturerCode,
              "manufacturerName": productDetails?.manufacturerName,
              "manufacturerPartNumber": productDetails?.manufacturerPartNumber,
              "quantityAvailableForSale": '',
              "backOrderedQuantity": productDetails?.backOrderedQuantity,
              "priceType": productDetails?.priceSource,
              "dateTimestamp": new Date().toISOString(),
              "displayedPrice": productDetails?.unitPrice,
              "cartAdditionSource": "PLP",
              "cartType": "checkout"
            }
          }
        ],
        ecommerce: {
          cartID:productDetails?.cartId
        },
        ...Info
      },
    };
    console.log('cartEventObj', cartEventObj)

    window.adobeDataLayer.push(cartEventObj);

  }

  static typeHeadSearchEvent(searchParam,tabType,linkName,url) {
    const searchEvent = {
      event: "typeheadSearch",
      _avnet: {
        internalSearchInfo: {
          searchType: "Internal",
          searchTerm: searchParam,
          searchTab: tabType,
        },
        linkInfo: {
          linkName: linkName,
          linkUrl: url,
          linkLocation: "typeheadSearchResults",
          linkType: "link",
          linkComponent: "typeheadPopup",
        },
        ...this.defaultInfo()
      },
    };
    window.adobeDataLayer.push(searchEvent);
  }

  static loadAvnetAnalytics = () => {
    if (typeof avnetAnalytics === 'object') {
      console.log("avnetAnalytics init called")
      avnetAnalytics.init();
    }
  }
  
  static bomSwitchToNewark(dataPoints) {
    const { selectedSite } = dataPoints;
    const bomSwitchToNewarkEvent = {
      "event": "siteSwitchInBom",
      "_avnet": {
        "siteSelected": selectedSite
      },
      ...this.defaultInfo()
    }
    window?.adobeDataLayer?.push(bomSwitchToNewarkEvent);
  } 

}
export default HelperAnalyticsEvent